export interface FlightRecord {
  timestamp: string;
  action: string;
  stateSnapshot: any;
}

export class FlightRecorder {
  private buffer: FlightRecord[] = [];
  private readonly maxSize: number;

  constructor(maxSize: number = 20) {
    this.maxSize = maxSize;
  }

  public record(action: string, stateSnapshot: any) {
    try {
      this.buffer.push({
        timestamp: new Date().toISOString(),
        action,
        // Deep copy to prevent reference mutations
        stateSnapshot: JSON.parse(JSON.stringify(stateSnapshot)),
      });
      if (this.buffer.length > this.maxSize) {
        this.buffer.shift();
      }
    } catch (e) {
      console.error("FlightRecorder failed to record state", e);
    }
  }

  public getLogs(): FlightRecord[] {
    return [...this.buffer];
  }

  public clear() {
    this.buffer = [];
  }
}
